module.exports = __webpack_public_path__ + "img/img50.139831ac.png";